module.exports = __webpack_public_path__ + "img/balkon10.ef360acf.jpg";